export const InboxLabel = {
    en: 'Inbox',
    es: 'Bandeja de Entrada',
};

export const InboxLabelShort = {
    en: 'Inbox',
    es: 'Bandeja',
};

export const NoMessagesLabel = {
    en: 'No messages.',
    es: 'No hay mensajes.',
};